import type { MarginSummary, PairPosition } from '../types.js';

export function aggregateMarginSummary(pairPositions: PairPosition[]): MarginSummary {
  let accountValue = 0;
  let totalCollateralUsed = 0;
  let totalNtlPos = 0;
  let totalRawPnlUsd = 0;
  let totalCumRollover = 0;
  let totalWithdrawable = 0;

  for (const { position } of pairPositions) {
    const collateral   = parseFloat(position.collateralUsed) || 0;
    const ntl          = parseFloat(position.ntl) || 0;
    const pnl          = parseFloat(position.unrealizedPnl) || 0;
    const rollover     = parseFloat(position.cumRollover) || 0;
    const withdrawable = parseFloat(position.maxWithdrawable) || 0;
    accountValue        += collateral + pnl;
    totalCollateralUsed += collateral;
    totalNtlPos         += ntl;
    totalRawPnlUsd      += pnl;
    totalCumRollover    += rollover;
    totalWithdrawable   += withdrawable;
  }

  return {
    accountValue:        accountValue.toString(),
    totalCollateralUsed: totalCollateralUsed.toString(),
    totalNtlPos:         totalNtlPos.toString(),
    totalRawPnlUsd:      totalRawPnlUsd.toString(),
    totalCumRollover:    totalCumRollover.toString(),
    totalWithdrawable:   totalWithdrawable.toString(),
  };
}
